const tabs = () => (
  [PAYMENTS, SENT_INVOICES, ACTION_REQUIRED]
)

export default {
  get tabs() { return tabs() }
}

//
const PAYMENTS = {
  label: 'Payments',
  href: { params: { page: 'Invoices', section: 'payments' } }
}

const SENT_INVOICES = {
  label: 'Invoices',
  href: { params: { page: 'Invoices', section: 'sent' } }
}

const ACTION_REQUIRED = {
  label: 'Action Required',
  href: { params: { page: 'Invoices', section: 'action-required' } }
}



// WEBPACK FOOTER //
// ./src/components/_modules/Invoices/tabs.js